import axios from 'axios'

const isNewVersion = () => {
  let url = `//${window.location.host}/static/version.json?t=${new Date().getTime()}`;
 return axios.get(url).then(res => {
    if (res.status === 200) {
      let vueVersion = res.data.version;
      let localVueVersion = localStorage.getItem('vueVersion');
      if (localVueVersion && localVueVersion != vueVersion) {
        localStorage.setItem('vueVersion', vueVersion);
        return false;
      } else {
        localStorage.setItem('vueVersion', vueVersion);
        return true
      }
    }
  });
}

export default {
  isNewVersion
}